/** @format */
import { ChangeDetectionStrategy, Component, Inject, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { ValidationErrorModalValues } from './validation-error-modal.component';

export function validationErrorModalFdOpener() {
    const fudisDialogService = inject(FudisDialogService);
    return (values: ValidationErrorModalValues) => fudisDialogService.open(ValidationErrorModalFdComponent, { data: values });
}

@Component({
    selector: 'sis-validation-error-modal-fd',
    templateUrl: './validation-error-modal-fd.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ValidationErrorModalFdComponent {
    constructor(@Inject(MAT_DIALOG_DATA) protected values: ValidationErrorModalValues) {}
}
